"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const calculateNextHighestZ=e=>e&&"string"!=typeof e?e+1:1;exports.calculateNextHighestZ=calculateNextHighestZ;
//# sourceMappingURL=styles.js.map
